import messages$1 from "./en/index.mjs";
import messages$2 from "./zh_cn/index.mjs";
import messages$3 from "./zh_tw/index.mjs";
const messages = {
  ...messages$1,
  ...messages$2,
  ...messages$3
};
export {
  messages as default
};
